import { captureException } from '@sentry/react'

export const toBase64 = (
  file: File
): Promise<{ name: string; base64: string }> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () =>
      resolve({ name: file.name, base64: reader.result as string })
    reader.onabort = (error) => reject(captureException(error))
    reader.onerror = (error) => reject(captureException(error))
  })

// Browsers often leave File.type empty for CAD drawings
export const getFileMimeType = (file: File): string => {
  if (file.type) return file.type
  return file.name.toLowerCase().endsWith('.dwg') ? 'image/vnd.dwg' : ''
}
